import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { useSite } from '../context/SiteContext';

const Footer = () => {
  const { brand, contact, footer } = useSite();
  if (!brand || !contact || !footer) return null;
  return (
    <footer className="border-t border-white/5 bg-[#04060b]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <span className="logo-chip rounded-xl border border-white/10 overflow-hidden inline-flex">
              <img src={brand.logoUrl} alt={brand.name} className="h-20 w-auto block" />
            </span>
            <p className="mt-5 text-sm text-slate-400 max-w-md leading-relaxed">
              {footer.tagline}
            </p>
          </div>

          {footer.columns.map((col) => (
            <div key={col.title}>
              <div className="text-xs uppercase tracking-widest text-slate-400 mb-4">{col.title}</div>
              <ul className="space-y-2 text-sm">
                {col.links.map((it) => (
                  <li key={it.href}>
                    <a href={it.href} className="text-slate-300 hover:text-brand-green-light btn-transition">
                      {it.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <div className="text-xs uppercase tracking-widest text-slate-400 mb-4">Contact</div>
            <ul className="space-y-3 text-sm text-slate-300">
              <li className="flex items-start gap-2"><MapPin className="h-4 w-4 text-brand-green-light mt-0.5 flex-shrink-0" /> {contact.address}</li>
              <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-brand-green-light flex-shrink-0" /> {contact.phone}</li>
              <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-brand-green-light flex-shrink-0" /> {contact.email}</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/5 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} {contact.company}. All rights reserved.
          </p>
          <p className="text-xs text-slate-500">{footer.subline}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
